<template lang="pug">
#app.inset-gutter-10px
    main.no-gutter
        HeaderNav(v-if="showNavMenu")
        .view-wrapper
            router-view.router-view(v-slot="{ Component, route }")
                //- transition(:name="route.meta.transition" mode="in-out" v-if="route.meta.transition")
                transition( mode="in-out" v-if="route.meta.transition")
                    keep-alive
                        component(
                            :is="Component"
                            :key="route.meta.usePathKey ? route.path : undefined"
                        )
                component(
                    :is="Component"
                    :key="route.meta.usePathKey ? route.path : undefined"
                )
        
        version.version
    //- footer
    //-     span Copyright ©{{year}}
</template>

<script lang="ts" setup>
import router,{ routes} from "../router";
import events from "../events";
import HeaderNav from "../components/header-nav.vue";
import Version from "../components/version.vue";
import { computed, onMounted, ref } from "vue";
const year = new Date().getFullYear()
const showNavMenu = ref(true)

router.beforeEach(to=>{
    showNavMenu.value = to.meta.showMenu as boolean;
})

onMounted(() => {
    (window as any).APPLICATION_LOADER.done();
})

</script>
<style lang="scss">
body{
    margin:unset;
}
#app > main{
    width: 100vw;
    height: 100vh;

    .view-wrapper{
        width:100%;
        height:100%;
    }
    #header-nav + .view-wrapper{
        height: calc(100% - 80px); //80px Height of the Navbar
    }
}
</style>
